var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c("div", { staticClass: "details-view" }, [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticClass: "tabs-container" },
          [
            _c(
              "el-tabs",
              {
                staticStyle: { width: "100%" },
                attrs: { type: "card" },
                on: { "tab-click": _vm.handleClick },
                model: {
                  value: _vm.activeTabName,
                  callback: function($$v) {
                    _vm.activeTabName = $$v
                  },
                  expression: "activeTabName"
                }
              },
              [
                _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_MsgClassifyManager"),
                      name: "msgClassifyManager"
                    }
                  },
                  [_c("msg-classify-manager-view")],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      lazy: true,
                      label: _vm.$t("CargoMsg.Cargo_BellMsg"),
                      name: "bellMsg"
                    }
                  },
                  [_c("bell-msg-view")],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }